export default "__VITE_ASSET__B1kiH0aR__"